module.exports = __webpack_public_path__ + "media/images/free-2c5a7da8b70c512aef9614b9571a96c6.svg";